module.exports = __webpack_public_path__ + "img/05.ab786328.jpg";